import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsHeatmap from 'highcharts/modules/heatmap';

// Initialize the Heatmap module
HighchartsHeatmap(Highcharts);

const HeatMap = ({ data, variety, loading }) => {
  // Show spinner while loading
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
        <CircularProgress />
      </Box>
    );
  }

  // Ensure data is valid
  if (!data || !data.valuesArray) {
    return <div>Error: None to display the heatmap.</div>;
  }

  // Modify y-axis categories to include the variety under Agmarknet
  const modifiedYAxis = data.y_axis.map((label) =>
    label
  );

  // Prepare the series data for the heatmap
  const seriesData = data.valuesArray.map(([x, y, value]) => [x, y, value]);

  // Highcharts configuration
  const options = {
    chart: {
      type: 'heatmap',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: data.x_axis,
    },
    yAxis: {
      categories: modifiedYAxis,
      title: {
        text: '',
      },
      labels: {
        useHTML: true, // Enables HTML in labels
      },
    },
    legend: {
      align: 'right',
      layout: 'vertical',
      verticalAlign: 'middle',
      itemStyle: {
        color: 'rgba(1, 97, 158, 0.2)',
      },
    },
    tooltip: { enabled: false },
    credits: false,
    colorAxis: {
      min: 0,
      max: 100,
      minColor: 'white',
      maxColor: '#01619E',
    },
    series: [
      {
        name: '',
        borderWidth: 1,
        data: seriesData,
        dataLabels: {
          enabled: true,
          color: '#000000',
        },
      },
    ],
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default HeatMap;
